import * as ko from "knockout";
import {IButton, IMessageData, IObjectData, IObjectType, IRouteDefinitionParams, ISyncField} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {nsRoute} from "../../util/route";
import {PLEASE_WAIT_MESSAGE} from "../../constants/Language";
import PromiseRequest from "../../req/PromiseRequest";
import {global} from "../../appContext";
import {SPINNER} from "../../constants";
import {Group} from "./list/group";
import {List} from "./list/details";
import {TServiceName} from "../../constants/ApiServices";
import {createErrorMessage} from "../../util/misc";
import {ButtonManager} from "../../util/ButtonManager";
import {nsFa} from "../fa/fn"
import {getRouteButton} from "../../constants/RouteDefinitions";
import {nsSystemfields} from "./nsSystemfields";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import detailsHtml from './details.html?raw';

const i = nsFa.i

export const template = detailsHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private data!: IObjectData;
    private list!: List
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly isVisible: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly req_getobjecttypes: PromiseRequest = global.getPromiseRequest('getobjecttypes')
    private requests!: PromiseRequest[]
    public objectTypes!: IObjectType[];
    private readonly headingButtons: ButtonManager = new ButtonManager()

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init();
    }

    private init(): Promise<any> {
        this.isReady(false);
        this.isVisible(false)
        this.messageData({message: PLEASE_WAIT_MESSAGE});

        const btn_export: IButton = getRouteButton('systemfieldsexport', {cssClass: 'action'})
        this.headingButtons.add(btn_export)

        if (nsSystemfields.isMutable) {
            const btn_import: IButton = getRouteButton('systemfieldsimport', {cssClass: 'action'})
            this.headingButtons.add(btn_import)

            const btn_copy: IButton = getRouteButton('systemfieldscopyall', {cssClass: 'action'})
            this.headingButtons.add(btn_copy)
        }

        return this.req_getobjecttypes.request()
            .then((data: IObjectType[]) => this.objectTypes = data)
            .then(() => {
                this.list = new List(this)
                this.messageData(null)
                this.isVisible(true)
                this.isReady(true)
            })
    }

    public submit(groups: KnockoutObservableArray<Group>) {
        this.isVisible(false)
        this.messageData({message: `((saving changes|td)) ${SPINNER}`});

        const _create = groups().filter(g => g.mode() == 'create')
        const _update = groups().filter(g => g.mode() == 'update' && g.isChanged())
        const _delete = groups().filter(g => g.mode() == 'delete')

        this.requests?.forEach(r => r.abort())
        this.requests = []

        Promise.resolve()
            // --- CREATE ----------------------------------------------------------------------------------------------
            .then(() => {
                const fn = (): Promise<ISyncField[]> => {
                    if (!_create.length) return Promise.resolve([])
                    const g = _create.shift()
                    if (!g) return fn()
                    const items = g.items.slice(0)
                    const fnSub = (): Promise<ISyncField[]> => {
                        if (!items.length) return fn()
                        const i = items.shift()
                        if (!i) return fnSub()
                        return Promise.resolve().then(() => {
                            const syncfield = i.getSubmitData();
                            syncfield.syncfieldid = g.syncfield.syncfieldid
                            if (!syncfield.displayname) {
                                return fnSub()
                            }
                            const jdisplayname = JSON.stringify(syncfield);
                            return this
                                .generateRequest("createsyncfielddisplayname", {jdisplayname: jdisplayname})
                                .then((data) => i.syncfield = data[0])
                                .then(() => fnSub())
                        })
                    }
                    return Promise.resolve().then(() => {
                        const jsyncfield = JSON.stringify(g.getSubmitData());
                        return this
                            .generateRequest('createsyncfield', {jsyncfield: jsyncfield})
                            .then((data) => g.syncfield = data[0])
                            .then(() => fnSub())
                    })
                }
                return fn()
            })
            // --- UPDATE ----------------------------------------------------------------------------------------------
            .then(() => {
                const fn = (): Promise<ISyncField[]> => {
                    if (!_update.length) return Promise.resolve([])
                    const g = _update.shift()
                    if (!g) return fn()
                    const items = g.items.slice(0)
                    const fnSub = (): Promise<ISyncField[]> => {
                        if (!items.length) return fn()
                        const i = items.shift()
                        if (!i) return fnSub()
                        return Promise.resolve().then(() => {
                            const syncfield = i.getSubmitData();
                            syncfield.syncfieldid = g.syncfield.syncfieldid
                            const dn = !!syncfield.displayname
                            let servicename: TServiceName
                            if (!!syncfield.syncfielddisplaynameid) {
                                if (dn)
                                    servicename = 'updatesyncfielddisplayname'
                                else
                                    servicename = 'deletesyncfielddisplayname'
                            } else {
                                if (dn)
                                    servicename = 'createsyncfielddisplayname'
                                else
                                    return fnSub()
                            }
                            return Promise.resolve()
                                .then(() => {
                                    switch (servicename) {
                                        case "updatesyncfielddisplayname": {
                                            const jdisplayname = JSON.stringify(syncfield);
                                            return this
                                                .generateRequest(servicename, {jdisplayname: jdisplayname})
                                        }
                                        case "createsyncfielddisplayname": {
                                            const jdisplayname = JSON.stringify(syncfield);
                                            return this
                                                .generateRequest(servicename, {jdisplayname: jdisplayname})
                                                .then((data) => i.syncfield = data[0])
                                        }
                                        case "deletesyncfielddisplayname": {
                                            return this
                                                .generateRequest(servicename, {id: i.syncfield.syncfielddisplaynameid})
                                        }
                                    }
                                })
                                .then(() => fnSub())
                        })
                    }
                    return Promise.resolve().then(() => {
                        const jsyncfield = JSON.stringify(g.getSubmitData());
                        return this
                            .generateRequest('updatesyncfield', {jsyncfield: jsyncfield})
                            .then((data) => g.syncfield = data[0])
                            .then(() => fnSub())
                    })
                }
                return fn()
            })
            // --- DELETE ----------------------------------------------------------------------------------------------
            .then(() => {
                const fn = (): Promise<ISyncField[]> => {
                    if (!_delete.length) return Promise.resolve([])
                    const g = _delete.shift()
                    if (!g) return fn()
                    const items = g.items.slice(0)
                    const fnSub = (): Promise<any> => {
                        if (!items.length) return fn()
                        const i = items.shift()
                        if (!i) return fnSub()
                        return Promise.resolve().then(() => {
                            if (!i.syncfield.syncfielddisplaynameid) return fnSub()
                            return this
                                .generateRequest('deletesyncfielddisplayname', {id: i.syncfield.syncfielddisplaynameid})
                                .then(() => fnSub())
                        })
                    }
                    return fnSub().then(() => {
                        return this.generateRequest('deletesyncfield', {id: g.syncfield.syncfieldid})
                            .then(() => fn())
                    })
                }
                return fn()
            })
            // --- CLEAN UP  -------------------------------------------------------------------------------------------
            .then(() => {
                global.cacheManager.removeCache("getsyncfields");
                global.cacheManager.removeCache("getobject");
                this.requests = [];
                this.messageData(null);
                global.snackbarData({message: `subject is updated|p|s:((system field|p))`});
                this.init()
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
                this.isVisible(true);
            });
    }

    private generateRequest(serviceName: TServiceName, params: any): Promise<any> {
        const p = new PromiseRequest(serviceName);
        this.requests.push(p);
        return p.request(params);
    }

    private prepareRequest(serviceName: TServiceName, params: any): () => Promise<any> {
        const p = new PromiseRequest(serviceName);
        this.requests.push(p);
        return p.request.bind(this, params);
    }

    override dispose() {
        super.dispose();
        this.req_getobjecttypes.abort()
    }
}
